import React, { Component } from "react";
import { connect } from 'react-redux';
import classNames from "classnames";
import { withTranslation } from 'react-i18next';
import * as roomActions from "../../reducers/room";

class RoomMessage extends Component {
  constructor(props) {
    super(props);
    this.linkClicked = this.linkClicked.bind(this);
  }

  componentDidUpdate() {
    const { hideMessage } = this.props;
    const { timer, displayRoomMessage } = this.props.roomMessage;

    if (displayRoomMessage && timer) {
      setTimeout(() => {
        if (hideMessage) {
          hideMessage();
        }
      }, timer);
    }
  }

  linkClicked() {
    const { hideMessage } = this.props;

    if (hideMessage) {
      hideMessage();
    }
  }

  render() {
    const {
      message,
      displayRoomMessage,
      type
    } = this.props.roomMessage;
    const { t } = this.props;
    return (
      <div
        className={classNames(
          { 'room-message': displayRoomMessage },
          { 'room-message-fadeout': !displayRoomMessage },
          { 'room-message-error': type && type === 'error' },
          { 'room-message-top': type && type === 'top' }
        )}
      >
        {t(message)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    roomMessage: state.room.roomMessage
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideMessage: () => {
      dispatch(roomActions.hideMessage());
    }
  };
};

const RoomMessageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RoomMessage);

export default withTranslation()(RoomMessageContainer);